import React from 'react';
import { motion } from 'framer-motion';
import { FiSmartphone, FiFileText, FiTrendingDown } from 'react-icons/fi';
import { useInView } from '../hooks/useInView';
import './HowItWorks.css';

const HowItWorks = () => {
  const [ref, isInView] = useInView({ threshold: 0.2, triggerOnce: true });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };

  const cardVariants = {
    hidden: { 
      opacity: 0, 
      y: 60,
      scale: 0.9
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 15
      }
    }
  };

  const iconVariants = {
    hidden: { scale: 0, rotate: -180 },
    visible: {
      scale: 1,
      rotate: 0,
      transition: {
        type: 'spring',
        stiffness: 200,
        damping: 15
      }
    }
  };

  const steps = [
    {
      icon: FiSmartphone,
      title: 'Show Snaply ID at checkout',
      description: 'Display your unique barcode to the cashier—works with any smartphone'
    },
    {
      icon: FiFileText,
      title: 'Receipt sent instantly to your phone',
      description: 'Your digital receipt appears in the app immediately after purchase'
    },
    {
      icon: FiTrendingDown,
      title: 'Track spending and environmental impact',
      description: 'See your purchase history and the trees you\'ve helped save'
    }
  ];

  return (
    <section className="how-it-works" id="how-it-works">
      <motion.div
        ref={ref}
        className="how-it-works-container"
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
      >
        <motion.div variants={cardVariants} className="section-header">
          <h2>How It Works</h2>
          <p>Three simple steps to paperless receipts</p>
        </motion.div>
        <div className="steps-grid">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="step-card"
              variants={cardVariants}
              whileHover={{
                y: -10,
                boxShadow: '0 20px 40px rgba(16, 185, 129, 0.15)',
                transition: { type: 'spring', stiffness: 300 }
              }}
            >
              <motion.div
                className="icon-wrapper"
                variants={iconVariants}
              >
                <step.icon />
              </motion.div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default HowItWorks;
